import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { Breadcrumbs } from "@/components/common";
import Header from "@/components/common/header";
import { Menu } from "@/components/common/menu";
import SidebarProvider from "@/components/ui/sidebar/context/sidebar-provider";
import useAuthVerify from "@/features/auth/hooks/use-auth-verify";

export const Route = createFileRoute("/_protected")({
  beforeLoad: async ({ context, location }) => {
    if (!context.auth.isLogin) throw redirect({ to: "/auth/login" });

    const userRole = context.auth.role;
    const currentPath = location.pathname;

    if (!userRole) return;

    const roleRoutePrefixes = {
      root: "/root",
      supplier: "/supplier",
      factory: "/factory",
    } as const;

    const allowedPrefix = roleRoutePrefixes[userRole];
    if (allowedPrefix && !currentPath.startsWith(allowedPrefix)) {
      const redirectPath = `${allowedPrefix}/home` as const;
      throw redirect({ to: redirectPath });
    }
  },
  component: RootComponent,
});

function RootComponent() {
  // 只在登入的頁面才進行驗證，避免在登入頁面時重複驗證
  useAuthVerify();

  return (
    <SidebarProvider>
      <Header />
      <Menu />
      <main className="mt-16 flex min-h-[calc(100vh-4.25rem)] w-full max-w-screen overflow-auto flex-col p-3">
        <Breadcrumbs />
        <Outlet />
      </main>
    </SidebarProvider>
  );
}
